
export const movingCalculator = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('moving-calculator.calculate', ({ output = {} }) => {
    const { calculatorType } = output;
    const thdAnalyticsEvent = {
      category: {
        primaryCategory: 'button submission'
      },
      eventInfo: {
        eventName: 'calculate'
      },
      calculate: {
        type: calculatorType
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(thdAnalyticsEvent);
  });
  window.LIFE_CYCLE_EVENT_BUS.on('moving-calculator.addToCartButton', ({ output = {} }) => {
    const { items = [] } = output;
    
    const allItems = items.map((item, index) => ({
      index: index + 1,
      sku: item.sku
    }));

    const thdAnalyticsEvent = {
      category: {
        primaryCategory: 'stash',
      },
      eventInfo: {
        eventName: 'cart add location',
      },
      eventMode: 'stash',
      stash: {
        pageType: 'tool:moving:calculator',
        sharedSection: '',
        section: '',
        component: '',
        target: 'atc',
        items: allItems
      },
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(thdAnalyticsEvent);
  });
  window.LIFE_CYCLE_EVENT_BUS.on('moving-calculator.addToCartSuccess', ({ output }) => {
    const { items = [], cartID, WCSCartID, OMS, cartTotal } = output

    const addedItemsValues = items.map((item) => ({

      productInfo: {
        sku: item.sku,
      },
      quantity: item.quantity,
      price: {
        basePrice: item.basePrice,
        priceType: item.priceType,
      },
      fulfillment: {
        method: item.fulfillmentMethod,
        store: item.store,
        zip: item.zip,
      },
    }));

    const cartItemsValues = items.map((item) => ({
      quantity: item.quantity,
      price: {
        basePrice: item.basePrice,
      },
      productInfo: {
        sku: item.sku,
        productName: item.productName,
        manufacturer: item.manufacturer,
        subCategory2: item.subCategory2,
      },
      fulfillment: {
        method: item.fulfillmentMethod,
        backorder: item.backorder ? 'yes' : 'no',
        store: item.store,
        zip: item.zip,
      },
    }));

    const DDOEvent = 
    {
      category: {
        primaryCategory: "overlay",
      },
      eventInfo: {
        eventName: "cart add",
      },
      items: addedItemsValues,
      cart: {
        cartID: cartID,
        attributes: {
          OMS: OMS,
        },
        price: {
          cartTotal: cartTotal,
        },
        items: cartItemsValues
      },
      legacy: {
        cartID: WCSCartID,
      },
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

};